import React, { useEffect, useState, lazy, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";

import ScrollToTop from "./ScrollToTop";
import Preloader from "./components/preloader";



const Home_v8 = lazy(() => import("./pages/Home_v8"));
const Blogs = lazy(() => import("./pages/Blogs"));
const Blog_v1 = lazy(() => import("./pages/Blog_v1"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const AboutUsDetails = lazy(() => import("./pages/AboutUsDetails"));
const Login = lazy(() => import("./pages/Login"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Results = lazy(() => import("./pages/Results"));
const PasswordReset = lazy(() => import("./pages/PasswordReset"));
const Assessment = lazy(() => import("./pages/Assessment"));
const AssessmentsPageUI = lazy(() => import("./pages/AssessmentsPageUI"));

const TanneryList = lazy(() => import("./pages/TanneryList"));
const TannerySpread = lazy(() => import("./pages/TannerySpread"));
const BrandsList = lazy(() => import("./pages/BrandsList"));
const AuthoritiesList = lazy(() => import("./pages/AuthoritiesList"));
const Edit = lazy(() => import("./pages/EditPage"));

const Certificates = lazy(() => import("./pages/Certificates"));
const CertificationView = lazy(() => import("./pages/CertificationView"));

const AdminControl = lazy(() => import("./pages/AdminControl"));

const InventoryViewPage = lazy(() =>
  import("./components/sections/InventoryViewPage")
);

const Mitigationplan = lazy(() =>
  import("./components/sections/Mitigationplan")
);

const MitigationEditPage = lazy(() =>
  import("./components/sections/MitigationEditPage")
);

const Ghg = lazy(() => import("./pages/Ghg"));
const Ghgone = lazy(() => import("./pages/Ghgone"));
const Interventions = lazy(() => import("./pages/Interventions"));
const LeatherType = lazy(() => import("./pages/LeatherType"));

/* -------------------- Routes -------------------- */

const App = () => {
  let routes = useRoutes([
    { path: "/", element: <Home_v8 /> },

    { path: "/blog_v1", element: <Blog_v1 /> },
    { path: "/blogs", element: <Blogs /> },

    { path: "/aboutus", element: <AboutUs /> },
    { path: "/aboutus-details", element: <AboutUsDetails /> },

    { path: "/login", element: <Login /> },
    { path: "/createaccount", element: <CreateAccount /> },

    { path: "/dashboard", element: <Dashboard /> },
    { path: "/results", element: <Results /> },
    { path: "/password-reset", element: <PasswordReset /> },

    { path: "/assessment", element: <Assessment /> },
    { path: "/assessment1", element: <Assessment /> },
    { path: "/assessment2", element: <Assessment /> },
    { path: "/assessment3", element: <Assessment /> },
    { path: "/assessment4", element: <Assessment /> },
    { path: "/assessment5", element: <Assessment /> },
    { path: "/assessment6", element: <Assessment /> },
    { path: "/assessment8", element: <Assessment /> },

    { path: "/assesment", element: <AssessmentsPageUI /> },

    { path: "/tannery-list", element: <TanneryList /> },
    { path: "/tannery-spread", element: <TannerySpread /> },
    { path: "/tannery-dashboard", element: <Results /> },

    { path: "/brands-list", element: <BrandsList /> },
    { path: "/authorities-list", element: <AuthoritiesList /> },
    { path: "/edit", element: <Edit /> },

    { path: "/certificates", element: <Certificates /> },
    { path: "/certification/:userId", element: <CertificationView /> },

    { path: "/admin-control", element: <AdminControl /> },

    { path: "/inventory/view/:id", element: <InventoryViewPage /> },

    { path: "/mitigation-plan", element: <Mitigationplan /> },
    { path: "/mitigation-plan/edit/:id", element: <MitigationEditPage /> },

    { path: "/ghg", element: <Ghg /> },
    { path: "/ghg-1", element: <Ghgone /> },

    { path: "/interventions", element: <Interventions /> },
    { path: "/leather-type", element: <LeatherType /> },
  ]);

  return routes;
};

/* -------------------- Wrapper -------------------- */

const AppWrapper = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {!loading ? (
        <Router>
          <ScrollToTop />

          {/* Lazy Loading Wrapper */}
          <Suspense fallback={<Preloader />}>
            <App />
          </Suspense>

        </Router>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default AppWrapper;
